import { IS_STAGING } from '@/config';

export default {
  computed: {
    isStaging() {
      return IS_STAGING;
    },
  },
};
